"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const axios_1 = __importDefault(require("axios"));
const useLocalStorage_1 = __importDefault(require("./useLocalStorage"));
const constants_1 = require("../constants");
const config_1 = __importDefault(require("../utils/config"));
const zenithApiPrivate_1 = __importDefault(require("../utils/zenithApiPrivate"));
const { zenithConfigApi } = (0, config_1.default)();
const userAccountUrl = `${zenithConfigApi}${constants_1.routes.USERS}`;
const loginUrl = `${userAccountUrl}/loginuser`;
const validateUrl = `${userAccountUrl}/validate`;
const loginApi = axios_1.default.create({});
exports.default = () => {
    const [user, setUser, clearUser] = (0, useLocalStorage_1.default)('LastUser', {});
    const [isLoggedIn, setIsLoggedIn] = (0, useLocalStorage_1.default)('LoggedIn', false);
    const [token, setToken, clearToken] = (0, useLocalStorage_1.default)('AuthToken', '');
    const [errorData, setErrorData] = (0, react_1.useState)(null);
    const signIn = (userName, password) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { data: resData } = yield loginApi.post(loginUrl, { userName, password });
            setUser(resData.data);
            setToken(resData.token);
            setIsLoggedIn(true);
        }
        catch (error) {
            setErrorData(error);
        }
    });
    const signOut = () => {
        clearUser();
        clearToken();
        setIsLoggedIn(false);
    };
    (0, react_1.useEffect)(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (isLoggedIn) {
                try {
                    yield zenithApiPrivate_1.default.get(validateUrl);
                    // const { status } = await zenithApiPrivate.get<Record<string, string>>(validateUrl)
                    // if (status === 200) {
                    //     console.info('Validated')
                    // }
                }
                catch (err) {
                    signOut();
                    window.location.replace('/login');
                }
            }
        }))();
    }, []);
    return { user, token, isLoggedIn, signIn, signOut, errorData };
};
